import { useSyncExternalStore } from "react";
import {
  getLocale,
  setLocale,
  subscribeLocale,
} from "@/pages/cogo-marketing/i18n/locale-store";
import { DEFAULT_LOCALE } from "@/pages/cogo-marketing/i18n/locales";
import { STUDIO_DICTIONARIES } from "./studio-dictionaries";

export function useStudioLocale() {
  const locale = useSyncExternalStore(
    subscribeLocale,
    getLocale,
    () => DEFAULT_LOCALE,
  );

  return {
    locale,
    setLocale,
    strings: STUDIO_DICTIONARIES[locale],
  };
}
